import type { PrivacyRegime, ViewState } from '@transcend-io/airgap.js-types';

import {
  FALLBACK_PRIVACY_CHOICES_VIEW_STATE,
  US_PRIVACY_CHOICES_VIEW_STATE,
  US_PRIVACY_REGIMES,
} from '@/constants';

// A bare showConsentManager() opens the on-load prompt (Hidden for some regimes). Mirrors Snappea.
export const privacyChoicesViewState = (
  regimes: Set<PrivacyRegime>,
  configured: Record<PrivacyRegime, ViewState> = {}
): ViewState => {
  const detected = Array.from(regimes);

  if (detected.every((regime) => US_PRIVACY_REGIMES.includes(regime.toLowerCase()))) {
    return US_PRIVACY_CHOICES_VIEW_STATE;
  }

  return (
    detected
      .map((regime) => configured[regime])
      .find((viewState) => viewState && viewState !== 'Hidden') ??
    FALLBACK_PRIVACY_CHOICES_VIEW_STATE
  );
};
